import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CommunityProfileType, UserSettings } from '@models';
import { UserBeanService } from '@services';

export const opensRoomsInsteadOfHome = ({ communityProfileId }: UserSettings) =>
  communityProfileId === CommunityProfileType.PROJECT_ROOM ||
  communityProfileId === undefined;

export const CommunityProfileGuard: CanActivateFn = async ({ queryParams }) => {
  const router = inject(Router);
  const userBean = await inject(UserBeanService).getUserBean();

  if (opensRoomsInsteadOfHome(userBean)) {
    return router.createUrlTree(
      [userBean.rootRoomsPermission < 1 ? '/shared-with-me' : '/rooms'],
      { queryParams }
    );
  }

  return true;
};
